
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Header from "@/shared/Header";
import Footer from "@/components/home-16/Footer";
import { PATHS } from "@/shared/publicPaths";

const HomeContainer=()=> {
  const { pathname } = useLocation();
  const needsHeaderOffset = [
    PATHS.privacy,
    PATHS.terms,
    PATHS.textMessage,
    PATHS.faq,
    PATHS.about,
  ].includes(pathname);

  return (
    <div className="min-h-screen flex flex-col">
    <Header /> 
      <section className={`home-container bg-home flex-1 ${needsHeaderOffset ? 'pt-24' : ''}`}>
        <Outlet />
      </section>
      <Footer />
  </div>
  );
}
export default HomeContainer;
